import { render, staticRenderFns } from "./error-page.view.vue?vue&type=template&id=75b45729&"
import script from "./error-page.view.vue?vue&type=script&lang=ts&"
export * from "./error-page.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports